import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/tables')({
  component: () => <Navigate to="/admin/dashboard" replace />,
})